module.exports = __webpack_public_path__ + "media/images/emblems/Tschugg-coat_of_arms-02afd34649a9d36bf108816b08fc4f35.svg";